import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MOBILE_BREAKPOINT = 767;

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const navLinks = [
    { to: '/about', label: 'About' },
    { to: '/services', label: 'Services' },
    { to: '/team', label: 'Team' },
    { to: '/blog', label: 'Blog' },
    { to: '/testimonials', label: 'Testimonials' },
    { to: '/faq', label: 'FAQ' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <header>
      <nav className="nav" aria-label="Main navigation">
        <button
          type="button"
          className="nav-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-controls="nav-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'} aria-hidden="true" />
        </button>
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/ph-therapy-logo.png" alt="PH Therapy" className="logo-img" style={{ height: 60 }} />
        </Link>
        <ul id="nav-menu" className={`nav-menu ${menuOpen ? 'nav-menu--open' : ''}`}>
          {isMobile && (
            <li className="nav-menu-close">
              <button
                type="button"
                onClick={closeMenu}
                aria-label="Close menu"
                className="nav-close-btn"
              >
                <i className="fas fa-times" aria-hidden="true" />
                Close
              </button>
            </li>
          )}
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link to={to} onClick={closeMenu}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;